<template>
    <b-form>
        <b-form-group :label="$t('tasks.taskgroup') + '*'">
            <b-form-select v-model="newTask.taskListId"
                           :options="projectTaskLists"
                           v-validate="'required'"
                           name="taskList"
                           :state="!veeErrors.has('taskList')">
                <template slot="first">
                    <option :value="null" disabled>-- {{ $t('tasks.selectTaskGroup') }} --</option>
                </template>
            </b-form-select>
            <span v-show="veeErrors.has('taskList')" style="color: red;" class="small">{{ $t('tasks.messages.validation.taskGroup') }}</span>
        </b-form-group>
        <b-form-group v-if="inputLimits">
            <template slot="label">
                <b-row>
                    <b-col cols="9">{{ $t('tasks.task') }}: *</b-col>
                    <b-col cols="3" class="text-right">
                        <small>
                            <b-badge>{{newTask.subject.length}} / {{inputLimits.taskName}}</b-badge>
                        </small>
                    </b-col>
                </b-row>
            </template>
            <b-form-input type="text"
                          v-model="newTask.subject"
                          :placeholder="$t('tasks.task')"
                          name="taskName"
                          v-validate="'required'"
                          :maxlength="inputLimits.taskName"
                          :state="!veeErrors.has('taskName')">
            </b-form-input>
            <span v-show="veeErrors.has('taskName')" style="color: red;" class="small">{{ $t('tasks.messages.validation.taskName') }}</span>
        </b-form-group>
        <b-form-group v-if="inputLimits" >
            <template slot="label">
                <b-row>
                    <b-col cols="9">{{ $t('tasks.description') }}:</b-col>
                    <b-col cols="3" class="text-right">
                        <small>
                            <b-badge>{{newTask.description.length}} / {{inputLimits.taskDescription}}</b-badge>
                        </small>
                    </b-col>
                </b-row>
            </template>
            <b-form-textarea name="newTaskDescription"
                             ref="newTaskDescription"
                             :maxlength="inputLimits.taskDescription"
                             v-model="newTask.description"
                             rows="3" max-rows="3" no-resize>
            </b-form-textarea>
        </b-form-group>
        <b-form-group>
            <b-row align-v="center">
                <b-col cols="8">
                    <label class="mb-0">{{ $t('tasks.assignProjectMember') }}:</label>
                </b-col>
                <b-col cols="4" class="text-right">
                    <b-btn @click="removeMember()" :disabled="selectedMember === null">
                        <small>{{ $t('tasks.removeAssignee') }}</small>
                    </b-btn>
                </b-col>
            </b-row>
            <v-autocomplete ref="autocompleteTaskAssignee"
                :items="projectCollaborators"
                v-model="selectedMember"
                :get-label="getLabel"
                :auto-select-one-item="false"
                :input-attrs="inputAttributes"
                :component-item="itemTemplate"
                @change="onInputChange"
                @update-items="filter">
            </v-autocomplete>
        </b-form-group>
    </b-form>
</template>

<script>
import _ from 'lodash';
import toastr from 'toastr';
import {mapState, mapGetters} from 'vuex';
import i18n from '@/i18n.bootstrap';
import ProjectMembersDialogTpl from '../Tasks/ProjectMembersDialogTpl';

export default {
    props: {
        file: Object
    },

    data() {
        return {
            fileData: this.file,
            newTask: {
                subject: '',
                description: '',
                assignedTo: '',
                taskListId: null
            },

            projectCollaborators: [],
            selectedMember: null,
            itemTemplate: ProjectMembersDialogTpl,
            inputAttributes: {
                class: 'form-control',
                placeholder: i18n.t('tasks.startTyping')
            }
        }
    },

    computed: {
        ...mapState('system', ['inputLimits']),
        ...mapGetters({projectMembers: 'projects/projectCollaborators'}),
        projectTaskLists() {
            return this.$store.getters['projects/projectTaskLists']
                        .map(item => {
                            return {
                                text: item.name,
                                value: item.id
                            }
                        });
        }
    },

    watch: {
        file(newVal) {
            this.fileData = newVal;
        },

        projectMembers(newArray) {
            this.projectCollaborators = newArray;
        }
    },

    methods: {
        removeMember() {
            this.selectedMember = null; 
            this.onInputChange();
            this.$refs.autocompleteTaskAssignee.$el.children[0].children[0].focus();
        },

        onInputChange(text) {
            if (!text || text === '') {
                this.projectCollaborators = _.cloneDeep(this.projectMembers);
            }
        },

        filter(searchText) {
            if (searchText && searchText !== '') {
                this.projectCollaborators = _.cloneDeep(this.projectMembers).filter(item => {
                    return (new RegExp(searchText.toLowerCase())).test(item['displayName'].toLowerCase());
                });
            }
        },

        getLabel(item) {
            if(item) return item.displayName;
        },

        clearForm() {
            this.newTask.subject = '';
            this.newTask.description = '';
            this.newTask.assignedTo = '';
            this.newTask.taskListId = null;
            this.selectedMember = null;
        },

        addTask() {
            this.$validator.validateAll()
                .then(result => {
                    if(result) {

                        if(this.selectedMember) this.newTask.assignedTo = this.selectedMember.id;
                        
                        let taskObj = {
                            task: {
                                subject: this.newTask.subject,
                                description: this.newTask.description,
                                assignedTo: this.newTask.assignedTo,
                                attachments: [this.fileData.id]
                            },
                            listId: this.newTask.taskListId
                        }
                        
                        this.$store.dispatch('projects/addTask', taskObj)
                            .then(() => {
                                this.$emit('closeCreateTaskModal');
                                toastr.success(i18n.t('tasks.messages.action.success'));
                            }).catch(() => {
                                toastr.error(i18n.t('tasks.messages.action.error'))
                            });
                        }
                });
        }
    }
}
</script>
